import React from 'react';
import { motion } from 'framer-motion';
import { Key, CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const steps = ['Por dónde empezar', 'Qué comprar', 'Cómo trabajar', 'Qué evitar'];
  return <section className="py-20 px-4 bg-gradient-to-b from-[#111] to-[#0a0a0a] border-t border-gray-800 pt-[31px] pb-[31px]" data-id="element-262">
      <div className="max-w-4xl mx-auto text-center" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-264">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-265">
            Lo que necesitás es un{' '}
            <span className="text-brand-yellow" data-id="element-266">paso a paso claro</span>
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 mb-12 font-medium" data-id="element-267">
            Saber exactamente:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-12" data-id="element-268">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1a1a1a] p-6 rounded-2xl border border-gray-800 flex items-center gap-4 text-left shadow-lg hover:border-brand-yellow/30 transition-colors" data-id="element-269">
                <CheckCircle2 className="w-8 h-8 text-green-500 flex-shrink-0" data-id="element-270" />
                <span className="text-xl font-bold text-white" data-id="element-271">{step}</span>
              </motion.div>)}
          </div>

          <p className="text-2xl md:text-4xl font-black text-gray-400 italic" data-id="element-272">
            Sin dudas. Sin vueltas.
          </p>
        </motion.div>
      </div>
    </section>;
}